import { loadingLottie } from "assets/lottie";
import {
  classDreamColor,
  classGreenColor,
  gray4,
  mainColor,
  mainDark4Color,
  mainSub1Color,
} from "assets/styleUtils";
import { EmptyView, Header } from "components";
import useInfiniteScroll from "hooks/useInfiniteScroll";
import Lottie from "lottie-react";
import { FixedModal } from "modal";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { headerState } from "recoil/header";
import { fetcher, post } from "utils/ApiUtil";
import styles from "./style.module.css";

interface IPointApply {
  no: number;
  name?: string;
  contructor_name?: string;
  phone?: string;
  join_day?: string;
  point?: string;
  payment_day?: string;
  pay_yn?: "N" | "Y";
  wedding_day: string | "";
}

export default function MyPointApplyListPage() {
  const navigation = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [showAlert, setShowAlert] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [pointApplyList, setPointApplyList] = useState<{
    result: IPointApply[];
    page: {
      cur: number;
      maxcnt: number;
      maxpage: number;
    };
  }>();
  const listRef = useRef<HTMLDivElement | null>(null);
  const setHeader = useSetRecoilState(headerState);

  setHeader({
    isVisible: true,
    title: "계약포인트",
    left: "back",
    right: {
      onClick: () => {
        setShowAlert(true);
      },
      text: "신청",
      color: mainColor,
    },
  });

  async function getList(page: number) {
    try {
      const {
        data: { result },
        success,
        message,
      } = await fetcher("/api/user/pointApplyList", { page });
      if (success) {
        setTotalPages(result.page.maxpage);
        if (page <= 1) {
          setPointApplyList(result);
        } else {
          setPointApplyList({
            ...result,
            result: [...(pointApplyList?.result || []), ...result.result],
          });
        }
      }
    } catch (error) {
      console.error("MyPointApplyPage getList error", error);
    } finally {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    getList(page);
  }, [page]);
  useInfiniteScroll({ page, setPage, ref: listRef, totalPages });

  return (
    <div style={{ backgroundColor: "#fff", flex: 1 }}>
      {showAlert && (
        <FixedModal
          title={"선택사항"}
          sub={`원하시는 포인트 신청을 선택해주세요.`}
          oneButton={{
            color: mainDark4Color,
            text: "웨딩홀 신청",
            onClick: () => {
              setShowAlert(false),
                navigation(
                  "/SignIn/MyPointList/PointApplyPage?category=weddinghall",
                );
            },
          }}
          twoRightButton={{
            color: classGreenColor,
            text: "기타 신청",
            onClick: () => {
              setShowAlert(false),
                navigation("/SignIn/MyPointList/PointApplyPage?category=etc");
            },
          }}
          onClick={() => setShowAlert(false)}
        />
      )}
      {isLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: 300,
            padding: 50,
          }}
        >
          <Lottie animationData={loadingLottie} loop={true} />
        </div>
      ) : pointApplyList && pointApplyList.result.length > 0 ? (
        <div style={{ padding: "20px" }}>
          <div>
            {pointApplyList?.result.map((item, index) => {
              const isPaid = item.pay_yn === "Y";
              return (
                <div
                  key={index}
                  className={styles.listItem}
                  style={{ display: "flex" }}
                >
                  <span>{item.contructor_name}</span>
                  <div
                    style={{ display: "flex" }}
                    // className={styles.itemRight}
                  >
                    {!!isPaid && (
                      <div className={styles.itemPoint}>
                        {String(item.point)} P
                      </div>
                    )}
                    <div
                      className={isPaid ? styles.textPaid : styles.textUnpaid}
                      style={{ marginLeft: "10px" }}
                    >
                      {isPaid ? "지급완료" : "신청완료"}
                      <img
                        style={{
                          width: "13px",
                          height: "13px",
                          cursor: "pointer",
                          marginLeft: "10px",
                        }}
                        src={"/images/right.png"}
                        alt="Right Arrow"
                        onClick={() => {
                          if (!!item.wedding_day) {
                            navigation(
                              `/SignIn/MyPointList/PointApplyPage?type=fix&no=${item.no}&category=weddinghall`,
                            );
                          } else {
                            navigation(
                              `/SignIn/MyPointList/PointApplyPage?type=fix&no=${item.no}&status`,
                            );
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div style={{ height: "80vh" }}>
          <EmptyView
            content={`현재는 신청 내역이 없습니다.
메이크마이웨딩을 통해 업체를 최종 계약하셨다면
우측 '신청' 버튼 클릭 후 캐시백 신청 부탁 드립니다.`}
          />
        </div>
      )}
      <div>
        {page <= totalPages && (
          <div
            ref={listRef}
            style={{
              width: "100%",
            }}
          />
        )}
      </div>
    </div>
  );
}
